module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_vm._l((_vm.datas[_vm.$i18n.locale]), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "sidebar-warpper",
      class: [_vm.currentValue == index + 1 ? 'current' : 'hide', ("sider_" + index), ("sider_" + (_vm.$i18n.locale))]
    }, [_c('a', {
      staticClass: "wall",
      attrs: {
        "href": data.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "wall-img"
    }, [_c('img', {
      attrs: {
        "src": data.img
      }
    })]), _c('div', {
      staticClass: "wall-box",
      class: {
        'wall-en': _vm.$i18n.locale === 'en'
      }
    }, [_vm._v("\n                " + _vm._s(data.text) + "\n                "), (data.subText) ? _c('p', [_vm._v(_vm._s(data.subText))]) : _vm._e()])]), _c('div', {
      staticClass: "friendly-show"
    }, [_c('img', {
      attrs: {
        "src": data.footer
      }
    })])])
  }), (_vm.$i18n.locale !== 'en') ? _c('div', {
    staticClass: "dot-box"
  }, [_c('div', {
    staticClass: "dot-inner"
  }, _vm._l((_vm.datas[_vm.$i18n.locale]), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "normal-dot",
      class: {
        active: index + 1 == _vm.currentValue
      },
      on: {
        "click": function($event) {
          return _vm.dosEvent(index + 1)
        }
      }
    })
  }), 0)]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37c2d310","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 541
// module chunks = 2 3